import { convertToRaw } from 'draft-js';
import { EditorState, RawDraftContentState } from 'react-draft-wysiwyg';

import { Parser } from './Parser.class';
import { EntityType } from './TextEditor.types';

export function parseToPortableText(editorState: EditorState): any {
  const rawContent: RawDraftContentState = convertToRaw(
    editorState.getCurrentContent(),
  );

  const { entityMap } = (rawContent as unknown) as { entityMap: EntityType };
  const sanitBlocks = [];
  rawContent.blocks.forEach((block) => {
    let { inlineStyleRanges } = block;
    const { entityRanges } = block;
    if (inlineStyleRanges.length) {
      inlineStyleRanges = inlineStyleRanges
        .filter(({ style }) => style === 'BOLD' || style === 'ITALIC')
        .sort((a, b) => a.offset - b.offset);
    }
    const parser = new Parser({
      entityMap,
      rawContentBlock: block,
      inlineStyleRanges,
      entityRanges,
    });

    parser.parseSainityBlock();

    if (parser._type === 'block' && !parser.children?.length) {
      return;
    }

    sanitBlocks.push(parser);
  });
  return sanitBlocks;
}
